import { useEffect, useRef, useState } from "react";
import type { AkvaryumSummaryDto } from "@sikilesi/protocol";
import { useServices } from "../components/Services";

/** How often the lake re-reads the akvaryum (public, edge-cached). No stream: catches are rare and cheap to poll. */
export const AKVARYUM_POLL_MS = 60_000;

export interface Akvaryum {
  summary: AkvaryumSummaryDto | null;
  /** Id of a catch that arrived since the page opened (the rod jerks once for it). */
  freshId: number | null;
}

export function useAkvaryum(): Akvaryum {
  const { api } = useServices();
  const [summary, setSummary] = useState<AkvaryumSummaryDto | null>(null);
  const [freshId, setFreshId] = useState<number | null>(null);
  const newest = useRef<number | null>(null);

  useEffect(() => {
    let live = true;
    const load = () => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
      api.akvaryum().then(
        (s) => {
          if (!live) return;
          const top = s.lake[0]?.id ?? null;
          if (newest.current !== null && top !== null && top > newest.current) setFreshId(top);
          if (top !== null) newest.current = top;
          setSummary(s);
        },
        () => undefined,
      );
    };
    load();
    const t = window.setInterval(load, AKVARYUM_POLL_MS);
    return () => {
      live = false;
      window.clearInterval(t);
    };
  }, [api]);

  return { summary, freshId };
}
